import request from '@/utils/request';

export function code(params) {
  return request({
    url: '/api/insure/index/code',
    method: 'get',
    params,
  });
}
export function phoneCode(params) {
  return request({
    url: '/api/insure/index/phoneCode',
    method: 'get',
    params,
  });
}
export function information(data) {
  return request({
    url: '/api/nonbid/index/save',
    method: 'post',
    data,
  });
}
export function getInformation(params) {
  return request({
    url: '/api/nonbid/index/detail',
    method: 'get',
    params,
  });
}
export function verify(data) {
  return request({
    url: '/api/insure/index/verify',
    method: 'post',
    data,
  });
}
export function insureCancel(data) {
  return request({
    url: '/api/insure/index/insureCancel',
    method: 'post',
    data,
  });
}
export function insureInvoice(data) {
  return request({
    url: '/api/insure/index/insureInvoice',
    method: 'post',
    data,
  });
}
export function applyInsureMoneyVerify(data) {
  return request({
    url: '/api/insure/index/applyInsureMoneyVerify',
    method: 'post',
    data,
  });
}
export function submitEnterprise(data) {
  return request({
    url: '/api/enterpriseInfo/submitEnterprise',
    method: 'post',
    data,
  });
}
export function getEnterprise(params) {
  return request({
    url: '/api/enterpriseInfo/getEnterprise',
    method: 'get',
    params,
  });
}

export function getList(params) {
  return request({
    url: '/api/agencyBasicInfo/list',
    method: 'get',
    params,
  });
}

export function getChannelInfo(params) {
  return request({
    url: '/api/insure/index/getChannelInfo',
    method: 'get',
    params,
  });
}


export function certType() {
  return request({
    url: '/api/dictDetail?dictName=certType',
    method: 'get',
  });
}

export function getDictInfo(name) {
  return request({
    url: `/api/dictDetail?dictName=${name}`,
    method: 'get',
  });
}

// invoiceType

export function startSign(params) {
  return request({
    url: '/api/contract/esign/startSign',
    method: 'get',
    params,
  });
}

export function basicInfo(params) {
  return request({
    url: '/api/agencyBasicInfo/list',
    method: 'get',
    params,
  });
}

export function getSignUrl(params) {
  return request({
    url: '/api/contract/getSignUrl',
    method: 'get',
    params,
  });
}

export function infoinformation(params) {
  return request({
    url: '/api/insure/index/info/information',
    method: 'get',
    params,
  });
}

export function getInformations(params) {
  return request({
    url: '/api/insure/index/info/information',
    method: 'get',
    params,
  });
}

export function getZjInfo(params) {
  return request({
    url: `/api/insurePay/zj/${params}`,
    method: 'get',
    params:{
      payChannel:'zjwy'
    }
  });
}
//
export function getZjCode(params) {
  return request({
    url: `/api/insurePay/zjCode/${params}`,
    method: 'get',
    params:{
      payChannel:'zjjh'
    }
  });
}

export function getLastAccount(params) {
  return request({
    url: `/api/insure/index/getLastAccount?orderNo=${params}`,
    method: 'get',
  });
}

export function getbackletterFormat(params) {
  return request({
    url: '/api/nonbid/index/backletterFormat',
    method: 'get',
    params,
  });
}
export function confirmInsure(data) {
  return request({
    url: '/api/nonbid/index/insure',
    method: 'post',
    data,
  });
}
export default { infoinformation, getZjCode,getZjInfo,getInformations,getDictInfo,getSignUrl, code, phoneCode, information, getInformation, verify, insureCancel, insureInvoice, applyInsureMoneyVerify, submitEnterprise, getEnterprise, getList, getChannelInfo, certType, startSign, basicInfo,getLastAccount,getbackletterFormat,confirmInsure };
